module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS6.0c522234.jpg";